import { render, staticRenderFns } from "./LineChart.vue?vue&type=template&id=532afbf2&scoped=true&"
import script from "./LineChart.vue?vue&type=script&lang=js&"
export * from "./LineChart.vue?vue&type=script&lang=js&"
import style0 from "./LineChart.vue?vue&type=style&index=0&id=532afbf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532afbf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('532afbf2')) {
      api.createRecord('532afbf2', component.options)
    } else {
      api.reload('532afbf2', component.options)
    }
    module.hot.accept("./LineChart.vue?vue&type=template&id=532afbf2&scoped=true&", function () {
      api.rerender('532afbf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/chartjs/LineChart.vue"
export default component.exports